import React from "react";
import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import { INTERNATIONAL_COUNTRY_LIST } from "../../utils/constants";

const BankAccountForm = ({ merchantIndex, values, handleChange, handleBlur, errors, touched, setFieldValue, isSubmitting, readOnly }) => {
  const prefix = `items[${merchantIndex}].bank_account`;

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h6" my={1}>
          Bank Account Details for Merchant #{merchantIndex + 1}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography align="right">Account Number *</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Account Number"
          margin="dense"
          fullWidth
          id={`${prefix}.account_number`}
          name={`${prefix}.account_number`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.account_number || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.account_number &&
            errors.items?.[merchantIndex]?.bank_account?.account_number
          )}
          helperText={
            touched.items?.[merchantIndex]?.bank_account?.account_number &&
            errors.items?.[merchantIndex]?.bank_account?.account_number
          }
          disabled={isSubmitting || readOnly}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography align="right">Account Name *</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Account Name"
          margin="dense"
          fullWidth
          id={`${prefix}.account_name`}
          name={`${prefix}.account_name`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.account_name || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.account_name &&
            errors.items?.[merchantIndex]?.bank_account?.account_name
          )}
          helperText={
            touched.items?.[merchantIndex]?.bank_account?.account_name &&
            errors.items?.[merchantIndex]?.bank_account?.account_name
          }
          disabled={isSubmitting || readOnly}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Typography align="right">Bank Name *</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Bank Name"
          margin="dense"
          fullWidth
          id={`${prefix}.bank`}
          name={`${prefix}.bank`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.bank || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(touched.items?.[merchantIndex]?.bank_account?.bank && errors.items?.[merchantIndex]?.bank_account?.bank)}
          helperText={touched.items?.[merchantIndex]?.bank_account?.bank && errors.items?.[merchantIndex]?.bank_account?.bank}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Bank Address</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Bank Address"
          margin="dense"
          fullWidth
          id={`${prefix}.bank_address`}
          name={`${prefix}.bank_address`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.bank_address || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.bank_address &&
            errors.items?.[merchantIndex]?.bank_account?.bank_address
          )}
          helperText={touched.items?.[merchantIndex]?.bank_account?.bank_address && errors.items?.[merchantIndex]?.bank_account?.bank_address}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Bank Country *</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <Autocomplete
          options={INTERNATIONAL_COUNTRY_LIST}
          getOptionLabel={(option) => option.name}
          value={INTERNATIONAL_COUNTRY_LIST.find(option => option.name === values.items?.[merchantIndex]?.bank_account?.bank_country?.toUpperCase()) || null}
          onChange={(event, newValue) => {
            setFieldValue(`${prefix}.bank_country`, newValue ? newValue.name : "");
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Bank Country"
              size="small"
              margin="dense"
              error={Boolean(touched.items?.[merchantIndex]?.bank_account?.bank_country && errors.items?.[merchantIndex]?.bank_account?.bank_country)}
              helperText={touched.items?.[merchantIndex]?.bank_account?.bank_country && errors.items?.[merchantIndex]?.bank_account?.bank_country}
              disabled={isSubmitting || readOnly}
            />
          )}
          isOptionEqualToValue={(option, value) => option.id === value.id}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Bank Branch Code</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Bank Branch Code"
          margin="dense"
          fullWidth
          id={`${prefix}.bank_branch_code`}
          name={`${prefix}.bank_branch_code`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.bank_branch_code || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.bank_branch_code &&
            errors.items?.[merchantIndex]?.bank_account?.bank_branch_code
          )}
          helperText={touched.items?.[merchantIndex]?.bank_account?.bank_branch_code && errors.items?.[merchantIndex]?.bank_account?.bank_branch_code}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">BIC/SWIFT Code *</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="BIC/SWIFT Code"
          margin="dense"
          fullWidth
          id={`${prefix}.bic_swift_code`}
          name={`${prefix}.bic_swift_code`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.bic_swift_code || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.bic_swift_code &&
            errors.items?.[merchantIndex]?.bank_account?.bic_swift_code
          )}
          helperText={
            touched.items?.[merchantIndex]?.bank_account?.bic_swift_code &&
            errors.items?.[merchantIndex]?.bank_account?.bic_swift_code
          }
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">IBAN{values.items?.[merchantIndex]?.bank_account?.bank_country && values.items?.[merchantIndex]?.bank_account?.bank_country.toUpperCase() !== 'SINGAPORE' ? ' *' : ''}</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="IBAN"
          margin="dense"
          fullWidth
          id={`${prefix}.iban`}
          name={`${prefix}.iban`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.iban || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(touched.items?.[merchantIndex]?.bank_account?.iban && errors.items?.[merchantIndex]?.bank_account?.iban)}
          helperText={touched.items?.[merchantIndex]?.bank_account?.iban && errors.items?.[merchantIndex]?.bank_account?.iban}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Bank Transfer Fee</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Bank Transfer Fee"
          margin="dense"
          fullWidth
          id={`${prefix}.bank_transfer_fee`}
          name={`${prefix}.bank_transfer_fee`}
          size="small"
          color="secondary"
          type="number"
          value={values.items?.[merchantIndex]?.bank_account?.bank_transfer_fee || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.bank_transfer_fee &&
            errors.items?.[merchantIndex]?.bank_account?.bank_transfer_fee
          )}
          helperText={
            touched.items?.[merchantIndex]?.bank_account?.bank_transfer_fee &&
            errors.items?.[merchantIndex]?.bank_account?.bank_transfer_fee
          }
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Settlement Fee</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Settlement Fee"
          margin="dense"
          fullWidth
          id={`${prefix}.settlement_fee`}
          name={`${prefix}.settlement_fee`}
          size="small"
          color="secondary"
          type="number"
          inputProps={{ min: 0, step: "0.01" }}
          value={values.items?.[merchantIndex]?.bank_account?.settlement_fee ?? 0.20}
          onChange={handleChange}
          onBlur={handleBlur}
          error={Boolean(
            touched.items?.[merchantIndex]?.bank_account?.settlement_fee &&
            errors.items?.[merchantIndex]?.bank_account?.settlement_fee
          )}
          helperText={
            (touched.items?.[merchantIndex]?.bank_account?.settlement_fee &&
              errors.items?.[merchantIndex]?.bank_account?.settlement_fee) ||
            "Enter 0.00 to waive"
          }
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Beneficiary Name</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Beneficiary Name"
          margin="dense"
          fullWidth
          id={`${prefix}.beneficiary_name`}
          name={`${prefix}.beneficiary_name`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.beneficiary_name || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Beneficiary Address</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Beneficiary Address"
          margin="dense"
          fullWidth
          id={`${prefix}.beneficiary_address`}
          name={`${prefix}.beneficiary_address`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.beneficiary_address || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Beneficiary Bank Code</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Beneficiary Bank Code"
          margin="dense"
          fullWidth
          id={`${prefix}.beneficiary_bank_code`}
          name={`${prefix}.beneficiary_bank_code`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.beneficiary_bank_code || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">
          Beneficiary Branch Code
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Beneficiary Branch Code"
          margin="dense"
          fullWidth
          id={`${prefix}.beneficiary_branch_code`}
          name={`${prefix}.beneficiary_branch_code`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.beneficiary_branch_code || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Intermediary Bank</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Intermediary Bank"
          margin="dense"
          fullWidth
          id={`${prefix}.intermediary_bank`}
          name={`${prefix}.intermediary_bank`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.intermediary_bank || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">
          Intermediary Bank Code
        </Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Intermediary Bank Code"
          margin="dense"
          fullWidth
          id={`${prefix}.intermediary_bank_code`}
          name={`${prefix}.intermediary_bank_code`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.intermediary_bank_code || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Intermediary Name</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          label="Intermediary Name"
          margin="dense"
          fullWidth
          id={`${prefix}.intermediary_name`}
          name={`${prefix}.intermediary_name`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.intermediary_name || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={isSubmitting || readOnly}
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <Typography align="right">Transfer Charge Pay By</Typography>
      </Grid>
      <Grid item xs={12} sm={3}>
        <TextField
          select
          label="Transfer Charge Pay By"
          margin="dense"
          fullWidth
          id={`${prefix}.transfer_charge_pay_by`}
          name={`${prefix}.transfer_charge_pay_by`}
          size="small"
          color="secondary"
          value={values.items?.[merchantIndex]?.bank_account?.transfer_charge_pay_by || 'Oxygen7'}
          onChange={handleChange}
          onBlur={handleBlur}
          SelectProps={{ native: true }}
          disabled={isSubmitting || readOnly}
        >
          <option value="Oxygen7">Oxygen7</option>
          <option value="Merchant">Merchant</option>
          <option value="Share">Share</option>
        </TextField>
      </Grid>
    </Grid>
  );
};

export default BankAccountForm;